var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUpWhite = function SvgArrowUpWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.385,
    height: 6.88
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.21 6.678 6.193 1.661 1.175 6.678a.688.688 0 0 1-.973-.973L5.706.2a.688.688 0 0 1 .973 0l5.506 5.505a.688.688 0 0 1-.973.973Z"
  })));
};
export default SvgArrowUpWhite;